'use strict';

require("intersection-observer");

document.addEventListener("DOMContentLoaded", () => {
  const controllers = document.querySelectorAll('.scrollcontroller__section');
  const threshold = [0, 0.2, 0.4, 0.6, 0.8, 1.0];

  const observer = new IntersectionObserver((changes) => {
    for (const change of changes) {
      const controller = change.target;
      const targetId = controller.id.replace(/scrollcontroller__/g , "");
      const target = document.querySelector("#"+targetId);
      // const rect = change.intersectionRect;
      const ratio = change.intersectionRatio;

      // console.log(change);
      // console.log(rect);
      // console.log(targetId + "->" + ratio);

      if (ratio > 0.5) {
        target.classList.remove("dive")
      } else {
        target.classList.add('dive');
      }
    }
  }, {
    threshold
  });

  for (const controller of controllers) {
    observer.observe(controller);
  }
}, false);



// WEBPACK FOOTER //
// ./src/js/script.js